const WalletHero = () =>
  import("../../../components/WalletPage/WalletHero/index");
const WalletTable = () =>
  import("../../../components/WalletPage/WalletTable/index");
import { WalletService } from "@/services";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

const CheckMarketTerms = () =>
  import("@/components/WalletPage/checkMarketTerms/index");
export default {
  name: "wallet-page",
  components: {
    WalletTable,
    WalletHero,
    CheckMarketTerms
  },
  props: [],
  data() {
    return {
      dialog: false,
      windowTop: window.top.scrolly
    };
  },
  computed: {
    ...mapGetters({
      getOpenModalMarketConditions:
        types.wallets.getters.GET_OPEN_MODAL_MARKET_CONDITIONS_WALLETS,
      userSetting: types.userSetting.getters.GET_USER_SETTING
    })
  },
  watch: {
    getOpenModalMarketConditions: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.dialog = newValue;
          this.setOpenModalConditionsMarket(null);
        }
      }
    }
  },
  mounted() {
    this.getWalletService();
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    ...mapActions({
      setNewWallets: types.wallets.actions.SET_NEW_WALLETS,
      // setCheckWallets: types.wallets.actions.SET_CHECK_WALLETS,
      // setExchangeWallets: types.wallets.actions.SET_EXCHANGES_WALLETS,
      setOpenModalConditionsMarket:
        types.wallets.actions.SET_OPEN_MODAL_MARKET_CONDITIONS_WALLETS
    }),
    onScroll() {
      this.windowTop = window.top.scrollY;
    },

    // getWalletService() {
    //   WalletService.getWalletV4().then(response => {
    //     let data = [];
    //     this.setNewWallets(response.data.data);
    //     response.data.data.wallets.forEach(elem => {
    //       data.push({
    //         id: elem.currency.id,
    //         show_update: elem.has_real_wallet
    //       });
    //     });
    //     this.setCheckWallets(data);
    //   });
    // },
    getWalletService() {
      WalletService.getWalletV2().then(response => {
        // let data = [];
        this.setNewWallets(response.data.data.wallets);
        // response.data.data.wallets.forEach(elem => {
        //   data.push({
        //     id: elem.iso,
        //     show_update: true
        //   });
        // });
        // this.setCheckWallets(data);
      });
    }
    // getExchangeService() {
    //   WalletService.getExchanges().then(response => {
    //     this.setExchangeWallets(response.data);
    //   });
    // },
  }
};
